import { render, staticRenderFns } from "./ImagesOfMonth.vue?vue&type=template&id=547e37cc&scoped=true"
import script from "./ImagesOfMonth.vue?vue&type=script&lang=js"
export * from "./ImagesOfMonth.vue?vue&type=script&lang=js"
import style0 from "./ImagesOfMonth.vue?vue&type=style&index=0&id=547e37cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e37cc",
  null
  
)

export default component.exports